// src/components/ProjectsTableModal.jsx
import React, { useState } from 'react';

const dataByYear = {
  '2020': [
    {
      number: '1',
      nomination: 'BrandGlobe Mastermind Grand Prix',
      teamCountry: 'Aira Wearables / 🇺🇦',
      captain: 'Марина Дорошенко (ex-Head of Brand, Ajax Systems)',
      focusMarkets: 'Украина, США, Канада',
      details: 'Модульный smart-бренд одежды: пластиковая «капсула-климат» защелкивается во внутренние карманы худи и регулирует температуру ±5 °C. Brand-book 48 стр.; план масштабирования — локальные сборки в Мексике и дистрибуция D2C. Привлек $310 k пред‑заказов на Kickstarter.'
    },
    {
      number: '2',
      nomination: 'Cross-Culture Navigator Award',
      teamCountry: 'TEAm Unity / 🇵🇱',
      captain: 'Ян Камінський (Strategy Lead, Allegro)',
      focusMarkets: 'Польша, Япония, Бразилия',
      details: 'AR-чайный пакетик: при наведении камеры кружка «оживает» авторской анимацией в стиле манга, folk‑визерунков и карнавал-граффити. 24 экспресс‑фокус‑группы; локализованы 3 Tone‑of‑Voice‑гайда; NPS 83 %.'
    },
    {
      number: '3',
      nomination: 'Digital Innovation Trailblazer',
      teamCountry: 'BlockDonate / 🇦🇪',
      captain: 'Лейла Хаддад (ex-Growth Lead, Careem)',
      focusMarkets: 'ОАЭ, Великобритания, Кения',
      details: 'Виджет стрим‑донатов на Ethereum; смарт‑контракт автоматически публикует отчет в Twitter. MVP open‑source, CR донатов +17 % к PayPal.'
    },
    {
      number: '4',
      nomination: 'Global Vision Grand Prix',
      teamCountry: 'Globio Kids AR / 🇨🇦',
      captain: 'Alex D’Souza (ex-Brand Dir., Spin Master)',
      focusMarkets: 'Канада, Испания, Филиппины',
      details: 'WebAR‑маскот появляется на коробке хлопьев и читает сказку на местном языке. Лицензионная модель для FMCG; прогноз ARR $2,4 млн.'
    },
    {
      number: '5',
      nomination: 'Culture Fusion Award',
      teamCountry: 'BabelBar / 🇮🇹',
      captain: 'Chiara Venturi (Brand Manager, Lavazza)',
      focusMarkets: 'Италия, Германия, Аргентина',
      details: 'Шоколад + аудиогид через QR: каждая плитка раскрывает историю какао на местном диалекте. Адаптация слогана «Dolce parola» → «Sweet Talk» → «Dulce Charla».'
    },
    {
      number: '6',
      nomination: 'Digital Innovation in Branding',
      teamCountry: 'MetaFit Mirror / 🇺🇸',
      captain: 'Carlos Ortega (ex-Product Mkt, Peloton)',
      focusMarkets: 'США, Мексика, Франция',
      details: 'IoT‑зеркало с AI‑тренером; TensorFlow.js + WebRTC, latency < 250 мс. Demo-зал в TikTok LIVE собрал 1,1 млн просмотров.'
    },
    {
      number: '7',
      nomination: 'Tech Disruptor Brand',
      teamCountry: 'LogiChain SaaS / 🇩🇪',
      captain: 'Helena Schmidt (ex-Lead Mkt, DHL Innovation)',
      focusMarkets: 'Германия, Чехия, Индия',
      details: 'SaaS для малых перевозчиков: QR‑трек, API для ERP, UX на SAP Fiori. Бесплатный tier — 3 груза/мес.; 1 000 активных компаний через четыре недели.'
    },
    {
      number: '8',
      nomination: 'Fashion & Lifestyle Icon',
      teamCountry: 'UP-cycle Me / 🇿🇦',
      captain: 'Nomsa Mokoena (Creative Mgr, Woolworths SA)',
      focusMarkets: 'ЮАР, Нидерланды, США',
      details: 'Апсайклинг‑деним: каждая пара джинсов — с NFC‑паспортом и VR‑filter для Snapchat. 28 000 подписчиков IG Shop за 14 дней.'
    },
    {
      number: '9',
      nomination: 'Social Impact Champion',
      teamCountry: 'SeeHear / 🇮🇳',
      captain: 'Priya Menon (Comms Lead, Tata Trusts)',
      focusMarkets: 'Индия, Малайзия, Кения',
      details: 'AI‑субтитры live‑ТВ для глухих; latency < 1 с, сервер‑cost $0,001/мин. Партнерство с Doordarshan, 15 k MAU.'
    },
    {
      number: '10',
      nomination: 'Audience Choice Award',
      teamCountry: 'PetMeet VR / 🇸🇬',
      captain: 'Gavin Loh (Founder, PawJoy)',
      focusMarkets: 'Сингапур, Австралия, Канада',
      details: 'VR‑прогулки для хозяев и приютских животных. 38 000 зрительских голосов, ER 19 %.'
    }
  ],
  '2021': [
    {
      number: '1',
      nomination: 'BrandGlobe Mastermind Grand Prix',
      teamCountry: 'Desert Bloom Skin / 🇦🇪',
      captain: 'Noura Al-Sari (ex-CMO, OasisLabs)',
      focusMarkets: 'ОАЭ, Польша, Казахстан',
      details: 'Clean-beauty-бренд из масла опунции, выращенной в бедуинских оазисах. Полный brand-book (72 стр.) связывает ингредиенты с SDG 12. Масштабирование — travel‑retail: эксклюзив в Warsaw Duty Free и Almaty Duty Free на 2022 г. Лонч‑кампания собрала 38 млн охвата, pre‑order $410 k.'
    },
    {
      number: '2',
      nomination: 'Cross‑Culture Navigator Award',
      teamCountry: 'FolkSoundNFT / 🇺🇦',
      captain: 'Ігор Семенюк (Marketing Lead, DMarket)',
      focusMarkets: 'Украина, Бразилия, Япония',
      details: 'Музыкальный NFT‑лейбл, где каждая токен‑«пластинка» — ремикс украинской, бразильской и японской народных тем. Провели 18 интервью с этномузыкантами, адаптировали копирайт без культурных коллизий. Drop #1 — 3 155 NFT, sold‑out за 9 мин.'
    },
    {
      number: '3',
      nomination: 'Digital Innovation Trailblazer',
      teamCountry: 'Try-On Air / 🇺🇸',
      captain: 'Lily Nguyen (ex-AR Lead, Warby Parker)',
      focusMarkets: 'США, Канада, Индонезия',
      details: 'AI‑GAN‑маска обуви (точность 96 %) + API для Shopify AR. Open‑репозиторий на GitHub, latency < 300 мс. 200 DTC‑брендов установили приложение за 30 дней; средний рост CR +11 %.'
    },
    {
      number: '4',
      nomination: 'Global Vision Grand Prix',
      teamCountry: 'EcoCart 360 / 🇩🇪',
      captain: 'Felix Becker (ex-Growth, Zalando)',
      focusMarkets: 'Германия, Швеция, Италия',
      details: 'Маркетплейс с отображением CO₂‑следа каждой покупки в реальном времени. Геймификация компенсаций дала +6 % CR и +18 % AOV. Финмодель — 4 % транзакционная комиссия; прогноз ARR €4,1 млн к концу 2023 г.'
    },
    {
      number: '5',
      nomination: 'Culture Fusion Award',
      teamCountry: 'Pão de Roma / 🇧🇷',
      captain: 'Luiz Favero (Brand Mgr., Bauducco)',
      focusMarkets: 'Бразилия, Италия, США',
      details: 'Линия фокаччи с бразильским асаи‑соусом. Упаковка сочетает карнавальный файл арта и ренессансные гравюры; слоган «Festa & Famiglia» успешно переведен без потери аллитерации. Слепой тест — 92 % предпочтения против местных аналогов.'
    },
    {
      number: '6',
      nomination: 'Digital Innovation in Branding',
      teamCountry: 'HoloChef / 🇬🇧',
      captain: 'Zoe Clark (Product Mkt, Ocado)',
      focusMarkets: 'Великобритания, ОАЭ, Индия',
      details: 'WebXR‑повар «телепортируется» на кухню, синк с умной плитой через Wi‑Fi. Интеграция с нутри‑трекером MyFitnessPal; средняя сессия — 11 мин. Партнерство с Tefal и Carrefour UAE.'
    },
    {
      number: '7',
      nomination: 'Tech Disruptor Brand',
      teamCountry: 'FinBot Kids / 🇮🇹',
      captain: 'Marco Contini (ex-CMO, UniCredit Youth)',
      focusMarkets: 'Италия, Испания, Мексика',
      details: 'Геймифицированная платформа фин‑грамотности для школ. UX‑квесты, open‑source сценарии; 43 школы пилотируют, churn < 3 %. Модуль API для банка‑партнёра выдал 5 k micro‑счетов за 1‑й месяц.'
    },
    {
      number: '8',
      nomination: 'Fashion & Lifestyle Icon',
      teamCountry: 'UrbanKay / 🇵🇱',
      captain: 'Ewa Zielińska (Creative Dir., Reserved)',
      focusMarkets: 'Польша, Германия, Франция',
      details: 'Streetwear из переработанных подушек безопасности VW. Каждая куртка снабжена NFT‑сертификатом и AR‑фильтром в IG. IG Shop 28 k подписчиков за 14 дней, sell‑through 80 %.'
    },
    {
      number: '9',
      nomination: 'Social Impact Champion',
      teamCountry: 'AgroSense / 🇰🇪',
      captain: 'James Kamau (Kenyan diaspora, 🇨🇦)',
      focusMarkets: 'Кения, Канада, Нидерланды',
      details: 'IoT‑датчики влажности + SMS‑советы на суахили; фермеры снижали расход воды на 32 %. В роадмапе — marketplace для продажи урожая.'
    },
    {
      number: '10',
      nomination: 'Audience Choice Award',
      teamCountry: 'DoggoSnap / 🇯🇵',
      captain: 'Haruka Ito (Founder, Kawaii Tech)',
      focusMarkets: 'Япония, Тайвань, США',
      details: 'AI‑генератор стикеров для питомцев; freemium‑модель, 72 k зрительских голосов, ER 21 %. За первые 24 ч продано 1 400 брендированных ошейников.'
    }
  ],
  '2022': [
    {
      number: '1',
      nomination: 'BrandGlobe Mastermind Grand Prix',
      teamCountry: 'MetaFarm XR / 🇨🇦',
      captain: 'Sophia Chen (ex-VP Brand, Freshii Digital)',
      focusMarkets: 'Канада, ОАЭ, Индия',
      details: 'Phygital-бренд «домашних ферм»: модульные гидропонные башни + AR‑метавселенная, где владельцы «выращивают» цифровые клоны реальных растений и обмениваются урожаем как NFT. Brand-book 84 стр.; roadmap — сборка в Дубае, франшиза в Бангалоре. Pre-order $520 k, партнерство с Carrefour UAE.'
    },
    {
      number: '2',
      nomination: 'Cross‑Culture Navigator Award',
      teamCountry: 'Nomad Noodles / 🇰🇿',
      captain: 'Daniyar Akhmetov (Brand Lead, Silk Route Foods)',
      focusMarkets: 'Казахстан, Италия, Южная Корея',
      details: 'Ритейл‑бренд лапши, объединяющий кочевую культуру степи, пасту аль денте и корейскую остроту. Проведено 30 street‑интервью в Алмате, Неаполе и Сеуле; упаковка меняет цвет под уровень остроты. Слоган «Три дороги — одна миска» адаптирован на 5 языков без потери ритма.'
    },
    {
      number: '3',
      nomination: 'Digital Innovation Trailblazer',
      teamCountry: 'SightPay / 🇩🇪',
      captain: 'Lars Krüger (ex-Growth, Deutsche Bank Digital)',
      focusMarkets: 'Германия, Великобритания, Австралия',
      details: 'Платеж по радужке прямо в AR-очки (WebXR + Edge-AI). MVP показал среднее время транзакции 0,7 с, false-reject 0,4 %. Репозиторий MIT‑лицензия, 240 звезд GitHub за неделю.'
    },
    {
      number: '4',
      nomination: 'Global Vision Grand Prix',
      teamCountry: 'TerraLoop Packaging / 🇯🇵',
      captain: 'Ayumi Nakamura (Sustainability CMO, Kirin Holdings)',
      focusMarkets: 'Япония, США, Бразилия',
      details: 'Биопластик из пивной дробины + цифровой двойник упаковки в блокчейне для end‑of‑life трекинга. Универсальная айдентика — «озоновый градиент» + иконки локальных экосистем. Финмодель: лицензия 0,8 ¢/шт.; прогноз ARR $6,3 млн к 2024.'
    },
    {
      number: '5',
      nomination: 'Culture Fusion Award',
      teamCountry: 'SambaKimchi / 🇧🇷',
      captain: 'Mariana Campos (Sr. Brand Strategist, Ambev)',
      focusMarkets: 'Бразилия, Южная Корея, США',
      details: 'Фьюжн‑закуска: кимчи, ферментированное в маракуйевом соку. Слоган «Fermenta alegria» — «Ferment the fun». Упаковка‑флаг: самба‑граффити с хангылем; комикс‑QR рассказывает о корнях обоих народов.'
    },
    {
      number: '6',
      nomination: 'Digital Innovation in Branding',
      teamCountry: 'Holo Homes / 🇬🇧',
      captain: 'Oliver Grant (Product Mkt, Rightmove XR)',
      focusMarkets: 'Великобритания, Саудовская Аравия, Испания',
      details: 'WebXR-сервис «телепортации» в строящиеся дома: лазер-сканы BIM + AI-рендер мебели. Интеграция c умными контрактами для бронирования. Среднее время тура 14 мин; CR брони +9 %.'
    },
    {
      number: '7',
      nomination: 'Tech Disruptor Brand',
      teamCountry: 'Quantum Fleet SaaS / 🇸🇬',
      captain: 'Kelvin Tan (ex-CMO, Grab Fleet)',
      focusMarkets: 'Сингапур, Германия, США',
      details: 'Платформа оптимизации логистики на квантовых алгоритмах. USP: 4× быстрее маршруты для 2000+ узлов. Open‑API; 12 логистических стартапов уже интегрированы, churn 0 %.'
    },
    {
      number: '8',
      nomination: 'Fashion & Lifestyle Icon',
      teamCountry: 'ReGlow Cosmetics / 🇮🇹',
      captain: 'Giulia Bianchi (Creative Dir., KIKO Labs)',
      focusMarkets: 'Италия, Франция, ОАЭ',
      details: 'Линия make-up‑тактов: упаковка с люминофором, заряжается на солнце → светится в клубе. ESG‑цепочка: отгрузка без пластика, refill‑системы. Коллаб с Vogue Arabia; в TikTok #ReGlow 67 млн просмотров за 10 дн.'
    },
    {
      number: '9',
      nomination: 'Social Impact Champion',
      teamCountry: 'SolarCart / 🇿🇦',
      captain: 'Thabo Dlamini (Impact CMO, GreenStep)',
      focusMarkets: 'ЮАР, Кения, Индия',
      details: 'Мобильная солнечная телега-продавец: панель 400 Вт + IoT-датчик качества воды. KPI: 124 микропредпринимателя, доход ↑ 36 %; отчетность SROI 4,2:1.'
    },
    {
      number: '10',
      nomination: 'Audience Choice Award',
      teamCountry: 'PawPrint 3D / 🇺🇦',
      captain: 'Olena Vozniak (Founder, MyPetCraft)',
      focusMarkets: 'Украина, Канада, Польша',
      details: 'Веб-сервис печати 3D-копий лап животных в виде брелоков; генератор AR-preview + NFT-паспорт. 84 000 зрительских голосов (ER 23 %), 5 200 заказов за первую неделю.'
    }
  ],
  '2023': [
    {
      number: '1',
      nomination: 'BrandGlobe Mastermind Grand Prix',
      teamCountry: 'PulseLoop AI / 🇸🇬',
      captain: 'Amelia Wong (ex‑CMO, HealthHub SG)',
      focusMarkets: 'Сингапур, Германия, Канада',
      details: 'Платформа, превращающая анонимные биоданные фитнес‑браслетов в персонализированные аудиопетли, которые пользователь может «слушать» в приложении‑медитаторе. Brand‑book 92 стр.; бизнес‑модель B2B2C (страховые, фитнес‑сети). Предзаказы от Allianz DE и GoodLife CA; MRR $180 k спустя 3 мес.'
    },
    {
      number: '2',
      nomination: 'Cross‑Culture Navigator Award',
      teamCountry: 'StoryClay / 🇧🇷',
      captain: 'Rafael Almeida (Cultural Marketing Lead, Globo)',
      focusMarkets: 'Бразилия, Украина, Япония',
      details: 'Линия детского экологичного пластилина, где набор историй генерируется ИИ‑рассказчиком на локальном фольклоре. Команда собрала 45 интервью мам‑мигрантов, адаптировала персонажей под кобзарскую, самурайскую и амазонскую традиции. NPS 88 %; упаковка имеет три слоя иллюстраций, меняющихся при освещении.'
    },
    {
      number: '3',
      nomination: 'Digital Innovation Trailblazer',
      teamCountry: 'VibeLens / 🇩🇪',
      captain: 'Lara Hoffmann (AR Innovation Lead, Adidas)',
      focusMarkets: 'Германия, США, Южная Корея',
      details: 'Генеративный AI‑фильтр обуви: пользователь сканирует кроссовку — VibeLens «дорисовывает» стиль на лету, формируя NFT‑скин для метавселенных. Edge‑AI < 250 мс; GitHub‑репо 420 ★ за неделю.'
    },
    {
      number: '4',
      nomination: 'Global Vision Grand Prix',
      teamCountry: 'EarthLoop Interiors / 🇺🇸',
      captain: 'Marcus Reed (Sustainability VP, IKEA US)',
      focusMarkets: 'США, Великобритания, Австралия',
      details: 'Модульная мебель из вытянутого океанического пластика + цифровой двойник в блокчейне, фиксирующий каждую переработку. Универсальная айдентика — «океанский градиент»; лицензия 1 ¢/кг сырья. ARR‑прогноз $7,8 млн к 2025.'
    },
    {
      number: '5',
      nomination: 'Culture Fusion Award',
      teamCountry: 'SpiceDiaries / 🇮🇹',
      captain: 'Sara Ferrari (Brand Strategist, Barilla Next)',
      focusMarkets: 'Италия, Индия, Мексика',
      details: 'Серия паст‑соусов с тремя «ступенями пряности»; упаковка объединяет мексиканский dia‑de‑los‑muertos‑паттерн с мадхубани‑пейзажами и трюфельным минимализмом. Слоган «Il Piccante che unisce» успешно локализован на Хинди и Испанский.'
    },
    {
      number: '6',
      nomination: 'Digital Innovation in Branding',
      teamCountry: 'EchoVerse / 🇬🇧',
      captain: 'Oliver Griffin (Product Mkt, BBC XR Lab)',
      focusMarkets: 'Великобритания, ОАЭ, Египет',
      details: 'WebXR‑портал, где покупатель мебели «ставит» предмет в свою комнату, а голосовой ассистент подстраивает освещение AR‑сцены под стиль интерьера. CR покупки +11 %; партнёрство с IKEA KSA.'
    },
    {
      number: '7',
      nomination: 'Tech Disruptor Brand',
      teamCountry: 'DroneDash SaaS / 🇨🇦',
      captain: 'Isabelle Marceau (ex‑CMO, Shopify Logistics)',
      focusMarkets: 'Канада, Япония, Катар',
      details: 'SaaS‑платформа оптимизации беспилотных доставок с квантовым маршрутизатором. 4× ускорение расчёта путей (2 000 узлов). 15 пилотных клиентов, churn 0 %.'
    },
    {
      number: '8',
      nomination: 'Fashion & Lifestyle Icon',
      teamCountry: 'Aurora Threads / 🇮🇳',
      captain: 'Meera Singh (Creative Dir., FabIndia Lab)',
      focusMarkets: 'Индия, Франция, ОАЭ',
      details: 'Текстиль из бамбукового волокна с люминесцентной нитью: светится пастельным «северным сиянием» под UV. Refill‑картриджи краски → zero‑waste. TikTok #AuroraGlow 72 млн просмотров за 12 дней.'
    },
    {
      number: '9',
      nomination: 'Social Impact Champion',
      teamCountry: 'AquaHope / 🇰🇪',
      captain: 'Faith Mwangi (Impact CMO, M‑PESA Foundation)',
      focusMarkets: 'Кения, Танзания, Индонезия',
      details: 'Портативные фильтры + приложение начисления «баллов чистой воды» (token‑rewards). 9 000 устройств в 3 деревнях → снижение болезней ЖКТ на 28 %. SROI 5,1:1.'
    },
    {
      number: '10',
      nomination: 'Audience Choice Award',
      teamCountry: 'ArtPet AI / 🇯🇵',
      captain: 'Yuki Sato (Founder, Pawsitive Tech)',
      focusMarkets: 'Япония, Тайвань, США',
      details: 'AI‑генератор аниме‑портретов питомцев; freemium, 96 000 голосов (ER 25 %). За 72 ч продано 8 400 холстов и 1 200 NFT‑редкопаков.'
    }
  ],

  '2024': [
    {
      number: '1',
      nomination: 'BrandGlobe Mastermind Grand Prix',
      teamCountry: 'FlashPack / 🇺🇸',
      captain: 'Jenna Morales (ex‑Head of Product Mkt, Herschel Supply)',
      focusMarkets: 'США, Япония, Франция',
      details: 'Phygital‑рюкзак Gen‑Z: две гнутые e‑ink‑панели на клапанах, кастом‑арт меняется через приложение (NFT‑подтверждение). Brand‑book 96 стр.; roadmap — сборка в Осаке и Париже, DTC в TikTok Shop. Предзаказ $730 k за 21 день; collab‑договор с Pokémon Co.'
    },
    {
      number: '2',
      nomination: 'Cross‑Culture Navigator Award',
      teamCountry: 'WanderBite / 🇮🇹',
      captain: 'Luca De Santis (Cultural Mkt Lead, Barilla)',
      focusMarkets: 'Италия, Таиланд, Мексика',
      details: 'Подписка «один рецепт — три культуры»: каждую неделю паста‑бейс, тайская специя и мексиканский соус. 42 street‑интервью; три цветовые палитры упаковки под рынки. Слоган «Mangia, Mingle, Muevo» сохранён во всех языках; NPS 90 %.'
    },
    {
      number: '3',
      nomination: 'Digital Innovation Trailblazer',
      teamCountry: 'HypeHue / 🇩🇪',
      captain: 'Tobias Keller (AR Lead, Puma)',
      focusMarkets: 'Германия, Великобритания, Южная Корея',
      details: 'AI‑кроссовка: камера определяет настроение — mid‑sole подсвечивается ML‑цветом. WebBLE‑чип + Edge‑AI (260 мс). GitHub‑репо MIT; 580 ★ за 5 дней; CR pre‑order +14 %.'
    },
    {
      number: '4',
      nomination: 'Global Vision Grand Prix',
      teamCountry: 'EcoSphere Paint / 🇬🇧',
      captain: 'Aisha Rahman (Sustainability CMO, AkzoNobel UK)',
      focusMarkets: 'Великобритания, ОАЭ, Индия',
      details: 'Карбон‑негативная водоэмульсия из микроводорослей; каждая банка создаёт «углеродный NFT‑твин», отслеживающий переработку. Айдентика — «кислородный градиент» + AR‑инструкция. Лицензия 1 ¢/л; ARR $8,1 млн к 2026.'
    },
    {
      number: '5',
      nomination: 'Culture Fusion Award',
      teamCountry: 'MapleMochi / 🇨🇦',
      captain: 'Claire Rousseau (Brand Strategist, Tim Hortons Labs)',
      focusMarkets: 'Канада, Япония, Бразилия',
      details: 'Замороженный десерт: кленовый сироп в рисовой «моти» + бразильский шоколад. Упаковка‑«флаг»: кленовый лист + хирагана + самба‑паттерн. Слоган «Que doçura!» → «Sweet‑eh!» → 「甘味で世界を」. 95 % blind‑test win.'
    },
    {
      number: '6',
      nomination: 'Digital Innovation in Branding',
      teamCountry: 'VibeDrop / 🇸🇬',
      captain: 'Kelvin Low (Product Mkt, Spotify SEA)',
      focusMarkets: 'Сингапур, США, Италия',
      details: 'Web3‑платформа: каждый Gen‑Z плейлист — «динамический NFT», аудио меняется по времени суток. Интеграция в Discord; DAO‑голосование обложек. MAU +18 %; грант AWS Activate $200 k.'
    },
    {
      number: '7',
      nomination: 'Tech Disruptor Brand',
      teamCountry: 'SkyCart Drone / 🇰🇿',
      captain: 'Azamat Esengeldinov (ex‑CMO, Kaspi Logistics)',
      focusMarkets: 'Казахстан, Германия, США',
      details: 'SaaS‑«мозг» для eVTOL‑доставок: гибридный квант‑алгоритм уменьшает расстояние на 37 %. Open‑API; 18 операторов интегрировались, churn 0 %.'
    },
    {
      number: '8',
      nomination: 'Fashion & Lifestyle Icon',
      teamCountry: 'LumiLink Jewelry / 🇺🇦',
      captain: 'Yelyzaveta Glukh (Creative Dir., Gunia Project)',
      focusMarkets: 'Украина, ОАЭ, Польша',
      details: 'Серебряные кулоны с невидимым проводником: NFC‑тап к смартфону и термохром меняет оттенок эмали под погоду. Коллаб с Vogue Eastern Europe; TikTok #LumiLink 74 млн просмотров за 9 дней.'
    },
    {
      number: '9',
      nomination: 'Social Impact Champion',
      teamCountry: 'HealthBox / 🇮🇳',
      captain: 'Rajiv Kapoor (Impact CMO, Tata Trusts)',
      focusMarkets: 'Индия, Бангладеш, Кения',
      details: 'IoT‑аптечка‑вендинг на солнечной панели: выдаёт базовые медикаменты, синхронизируется с e‑Gov‑ID. 210 установок, время доступа к лекарствам ↓ 42 %, SROI 4,9:1.'
    },
    {
      number: '10',
      nomination: 'Audience Choice Award',
      teamCountry: 'SnapTaste / 🇵🇱',
      captain: 'Agnieszka Nowak (Founder, SweetAR)',
      focusMarkets: 'Польша, Украина, США',
      details: 'AR‑фильтр: фото блюда → «рецепт‑ролик» + заказ ингредиентов в один тап. 96 000 голосов (ER 24 %); 6 300 покупок HelloFresh US за 48 ч.'
    }
  ],
  '2025': [
  {
    number: '1',
    nomination: 'BrandGlobe Mastermind Grand Prix',
    teamCountry: 'NeuroCart / 🇰🇿',
    captain: 'Марат Нургалиев (Head of MarTech, Kaspi.kz)',
    focusMarkets: 'Казахстан, ОАЭ, Польша',
    details: 'AI-платформа динамического оффера: в реальном времени меняет цену/комплект/месседж под сегмент и контекст (погода, спрос, склад). 7 A/B+holdout тестов; uplift конверсии +19%; окупаемость 10 недель.'
  },
  {
    number: '2',
    nomination: 'Cross-Culture Navigator Award',
    teamCountry: 'ToneAtlas / 🇺🇦',
    captain: 'Юлия Осадчук (Growth Lead, ex-Product Marketing)',
    focusMarkets: 'Украина, Германия, Канада',
    details: '«Переводчик смысла» для брендов: генерация Tone-of-Voice по культурным кодам (юмор/формальность/табу). 16 локальных редакторов; 40 mini-фокус-групп; brand-lift +8 п.п. на тестовом запуске.'
  },
  {
    number: '3',
    nomination: 'Digital Innovation Trailblazer',
    teamCountry: 'TrustQR / 🇬🇪',
    captain: 'Мариам Чхеидзе (PR & Reputation Strategist)',
    focusMarkets: 'Грузия, Великобритания, Индия',
    details: 'QR-паспорта доверия: при сканировании — прозрачная цепочка «производство-логистика-сертификация» + модуль crisis-response. Интеграция с GS1; снижение негативных упоминаний −25% за 30 дней.'
  },
  {
    number: '4',
    nomination: 'Global Vision Grand Prix',
    teamCountry: 'EduMascot WebAR / 🇵🇱',
    captain: 'Доминик Вишневский (Brand Comms Strategist)',
    focusMarkets: 'Польша, Япония, Бразилия',
    details: 'WebAR-маскот на упаковке: говорит на языке региона и подстраивает сюжет под возраст. 14 сценариев; retention 7-day 32%; лицензирование для FMCG с прогнозом ARR €1,7 млн.'
  },
  {
    number: '5',
    nomination: 'Culture Fusion Award',
    teamCountry: 'BabelTaste / 🇮🇹',
    captain: 'Giulia Ferraro (Brand Manager, Lavazza)',
    focusMarkets: 'Италия, США, Аргентина',
    details: '«Вкус+история»: дегустационный набор с аудиогидом по диалектам и локальными коллаборациями художников. 6 версий упаковки; NPS 79; PR-охват 13,6 млн.'
  },
  {
    number: '6',
    nomination: 'Digital Innovation in Branding',
    teamCountry: 'MirrorCoach Live / 🇺🇸',
    captain: 'Daniel Rivera (ex-Product Marketing, fitness tech)',
    focusMarkets: 'США, Мексика, Франция',
    details: 'Smart-зеркало с AI-коучем и live-классами (WebRTC + on-device pose). latency < 230 мс; 1,4 млн просмотров demo-стримов; подписка конверсия 6,1%.'
  },
  {
    number: '7',
    nomination: 'Tech Disruptor Brand',
    teamCountry: 'FleetFlow SaaS / 🇩🇪',
    captain: 'Lara Neumann (ex-Lead Marketing, logistics)',
    focusMarkets: 'Германия, Чехия, Индия',
    details: 'SaaS для малого флота: QR-трек, e-POD, API к ERP, контроль температуры. Freemium 6 доставок/мес.; 1 250 активных компаний за 30 дней.'
  },
  {
    number: '8',
    nomination: 'Fashion & Lifestyle Icon',
    teamCountry: 'UpCycle ID / 🇿🇦',
    captain: 'Thandi Maseko (Creative Manager, retail)',
    focusMarkets: 'ЮАР, Нидерланды, США',
    details: 'Апсайклинг-капсулы одежды с NFC-паспортом: происхождение ткани, уход, resale-оценка. AR-фильтр для примерки; 39k подписчиков IG Shop за 3 недели.'
  },
  {
    number: '9',
    nomination: 'Social Impact Champion',
    teamCountry: 'SignStream AI / 🇮🇳',
    captain: 'Ananya Rao (Comms Lead, NGO sector)',
    focusMarkets: 'Индия, Малайзия, Кения',
    details: 'Live-субтитры + перевод на жестовый аватар для гос-стримов. latency < 1 c; cost $0,0014/мин; 20k MAU; пилот с национальным вещателем.'
  },
  {
    number: '10',
    nomination: 'Audience Choice Award',
    teamCountry: 'ShelterWalk VR / 🇸🇬',
    captain: 'Marcus Tan (Founder, pet-tech)',
    focusMarkets: 'Сингапур, Австралия, Канада',
    details: 'VR-прогулки с питомцами из приютов + донаты «в один клик». 48 000 голосов; ER 21%; 2 900 новых заявок на усыновление через партнёров.'
  }
]
};

const ProjectsTableModal = () => {
  const [expanded, setExpanded] = useState(false);


  const years = Object.entries(dataByYear);

  // показываем либо только первый год, либо все
  const visibleYears = expanded ? years : years.slice(0, 1);

  return (
    <section id='winners' className="nominations">
      <div className="container">
        <h2 className="nominations__heading">
          Проекты‑победители<br/>BrandGlobe Hackathon
        </h2>


          <table className="nominations__table">
            <thead>
              <tr>
                <th>№</th>
                <th>Номинация</th>
                <th>Команда / страна капитана</th>
                <th>Капитан</th>
                <th>Фокус‑рынки</th>
                <th>Детали проекта</th>
              </tr>
            </thead>
            <tbody>
              {visibleYears.map(([year, rows]) => (
                <React.Fragment key={year}>
                  <tr className="nominations__year-row">
                    <td colSpan={6} className="nominations__year-cell">
                      {year}
                    </td>
                  </tr>
                  {rows.map(r => (
                    <tr key={year + r.number}>
                      <td>{r.number}</td>
                      <td>{r.nomination}</td>
                      <td>{r.teamCountry}</td>
                      <td>{r.captain}</td>
                      <td>{r.focusMarkets}</td>
                      <td>{r.details}</td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>


        <button
          className="nominations__show-btn"
          onClick={() => setExpanded(e => !e)}
        >
          {expanded ? 'Скрыть все годы ▲' : 'Показать все года ▼'}
        </button>
      </div>
    </section>
  );
};

export default ProjectsTableModal;
